import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../../../../partials/aside/Sidebar";
import { DatePicker } from "react-advance-jalaali-datepicker";
import helpersNumbers from "../../../../../helpers/numbers";
import validateFormsGiftUserRegister from "../../../../../validtions/forms/gift-user-register/add";
import helperSpinner from "../../../../../helpers/spinner";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersTime from "../../../../../helpers/time";

export default function Edit() {
  const [giftRegisterUser, setGiftRegisterUser] = useState();
  const [amount, setAmount] = useState();
  const params = useParams();
  const giftID = params.giftID;

  const [message, setMessage] = useState();
  const history = useHistory();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    getGiftRegisterUser();
  }, []);

  const getGiftRegisterUser = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetGiftRegisterUser =
      await sendRequestGiftRegisterUser();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetGiftRegisterUser) {
      return;
    }

    setGiftRegisterUser(resultSendRequestGetGiftRegisterUser);
    setAmount(resultSendRequestGetGiftRegisterUser.gru_amount);
  };

  const sendRequestGiftRegisterUser = async () => {
    let result;
    let headersRequest = getHeaderForRequest();
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/gift-user-register/manage/" +
          giftID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const inputAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setAmount(parseInt(number));
  };

  const inputAmountBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const getDateForm = () => {
    return {
      amount: amount + "",
      start_date: getStartDate() + ":00",
      end_date: getEndDate() + ":00",
      description: document.querySelector("#description").value,
    };
  };

  const getStartDate = () => {
    return `${helpersTime.convertJalaliToGregorian(
      document.querySelector("#start-date input").value
    )} ${document.querySelector("#hour-start-date").value}:${
      document.querySelector("#minute-start-date").value
    }`;
  };

  const getEndDate = () => {
    return `${helpersTime.convertJalaliToGregorian(
      document.querySelector("#end-date input").value
    )} ${document.querySelector("#hour-end-date").value}:${
      document.querySelector("#minute-end-date").value
    }`;
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const dataForm = getDateForm();
    const resultValidate = validateFormsGiftUserRegister(dataForm);
    if (resultValidate != true) {
      setMessage({
        type_class: "alert alert-danger ",
        text: resultValidate,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestEditGiftRegisterUser =
      await sendRequestEditGiftRegisterUser(dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestEditGiftRegisterUser) {
      return;
    }
    history.push("/finance/manage/gift-register-user/all");
  };

  const sendRequestEditGiftRegisterUser = async (giftRegisterUser) => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/gift-user-register/manage/" +
          giftID,
        giftRegisterUser,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger ",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return false;
    }

    return true;
  };

  const scrollForSeeMessage = () => {
    const element = document.querySelector(".card-body");
    element.scrollIntoView();
  };

  const generateForm = () => {
    return (
      <form onSubmit={sendForm}>
        <div>
          <div className="pb-2">
            <label>مبلغ هدیه</label>
          </div>
          <div>
            <div class="input-group">
              <input
                type="text"
                id="amount"
                class="form-control number-finance"
                value={helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(amount)
                )}
                onChange={inputAmountChangeHandler}
                onBeforeInput={inputAmountBeforeInputHandler}
                dir="ltr"
              />
              <div class="input-group-append">
                <span class="input-group-text">تومان</span>
              </div>
            </div>
          </div>
        </div>

        <div className="py-2">
          <div>
            <label>تاریخ شروع</label>
          </div>
          <div className="d-flex align-items-center">
            <div id="start-date" className="custom-data-picker ">
              <DatePicker
                placeholder="انتخاب تاریخ"
                format="jYYYY/jMM/jDD"
                preSelected={helpersTime.convertGregorianToJalali(
                  giftRegisterUser.gru_start_date.split(" ")[0]
                )}
              />
            </div>
            <div className="text-nowrap pr-2">ساعت :</div>
            <div className="px-2">
              <input
                className="form-control"
                type="number"
                id="hour-start-date"
                min="0"
                max="23"
                defaultValue={
                  giftRegisterUser.gru_start_date.split(" ")[1].split(":")[0]
                }
                required
              />
            </div>
            <div className="text-nowrap">دقیقه :</div>
            <div className="pr-2">
              <input
                className="form-control"
                type="number"
                id="minute-start-date"
                min="0"
                max="59"
                defaultValue={
                  giftRegisterUser.gru_start_date.split(" ")[1].split(":")[1]
                }
                required
              />
            </div>
          </div>
        </div>

        <div className="py-2">
          <div>
            <label>تاریخ پایان</label>
          </div>
          <div className="d-flex align-items-center">
            <div id="end-date" className="custom-data-picker ">
              <DatePicker
                placeholder="انتخاب تاریخ"
                format="jYYYY/jMM/jDD"
                preSelected={helpersTime.convertGregorianToJalali(
                  giftRegisterUser.gru_end_date.split(" ")[0]
                )}
              />
            </div>
            <div className="text-nowrap pr-2">ساعت :</div>
            <div className="px-2">
              <input
                className="form-control"
                type="number"
                id="hour-end-date"
                min="0"
                max="23"
                defaultValue={
                  giftRegisterUser.gru_end_date.split(" ")[1].split(":")[0]
                }
                required
              />
            </div>
            <div className="text-nowrap">دقیقه :</div>
            <div className="pr-2">
              <input
                className="form-control"
                type="number"
                id="minute-end-date"
                min="0"
                max="59"
                defaultValue={
                  giftRegisterUser.gru_end_date.split(" ")[1].split(":")[1]
                }
                required
              />
            </div>
          </div>
        </div>
        <div className="pb-2">
          <div>
            <label>توضیحات</label>
          </div>
          <textarea className="form-control" id="description" rows="5" required>
            {giftRegisterUser.gru_description}
          </textarea>
        </div>
        <button className="btn btn-primary">ویرایش کردن</button>
      </form>
    );
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4 pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">
                  اضافه کردن هدایای ثبت نام کاربران
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <div class="text-left pb-2">
                <Link
                  class="btn btn-primary"
                  to="/finance/manage/gift-register-user/all"
                >
                  <span>بازگشت</span>
                  <span class="pr-2">
                    <i class="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div className="alert alert-warning ">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>
                  توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      ساعت تاریخ شروع و پایان ۲۴ ساعته است.
                    </p>
                  </li>
                </ul>
              </div>
              {messageTag}
              {giftRegisterUser && generateForm()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
